export default {
  // State をリセット
  RESET_STATE: 'transactionHistoryResetState',

  // 取引一覧を取得
  QUERY_TRANSACTION_LIST: 'transactionHistoryQueryTransactionList',
  // 一覧情報を設置
  SET_LIST_SORT_INFO: 'transactionHistorySetListSortInfo',
  SET_CURRENT_SORT_COLUMN_ID: 'transactionHistorySetCurrentSortColumnID',
  SET_LIST_PAGE_INFO: 'transactionHistorySetListPageInfo',
  // 商品情報
  SET_PRODUCT_INFO: 'transactionHistorySetProductInfo',

  // 一覧種別を設置
  SET_ACTIVE_LIST_TYPE: 'transactionHistorySetActiveListType',
  // 一覧状態を設置
  SET_ACTIVE_LIST_STATUS: 'transactionHistorySetActiveListStatus',

  // 請求ロックを設置
  SET_REQUEST_LOCK_STATUS: 'transactionHistorySetRequestLockStatus',
}
